import React from 'react';
import ProtectedRoute from './protected';
import Dashboard from '../pages/dashboard';
import Logout from '../pages/logout';

export const DashboardRoutes = [
  <ProtectedRoute exact path='/dashboard' component={Dashboard} />,
  <ProtectedRoute exact path='/logout' component={Logout} />,
]